import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  sortBy,
  filter,
} from 'lodash';
import {
  makeStyles,
  Grid,
  Paper,
  IconButton,
  Icon,
  Typography,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import SyntaxHighlighter from 'react-syntax-highlighter';

import styles from './styles';

const useStyles = makeStyles(styles);

export const FormsListComponent = (props) => {
  const {
    forms,
    includeArchived,
    onEditClick,
    onArchiveClick,
    isLoading,
  } = props;
  const classes = useStyles();

  // local state
  const [showCodeForForm, setShowCodeForForm] = useState(null);

  const sortedForms = sortBy(filter(forms, (form) => includeArchived || !form.archived), 'statusOrder');

  return (
    <Grid container>
      <Grid item xs={12}>
        <MaterialTable
          title="Forms"
          data={sortedForms}
          options={{
            search: false,
            toolbar: false,
            paging: false,
          }}
          components={{ Container: Paper }}
          columns={[
            {
              title: 'Title',
              field: 'title',
            },
            {
              title: 'Description',
              field: 'description',
              render: (form) => (
                <Tooltip title={form.description}><Typography noWrap variant="body1" className={classes.truncateTypography}>{form.description}</Typography></Tooltip>
              ),
            },
            {
              title: 'Form Type',
              field: 'type',
            },
            {
              title: '',
              field: 'id',
              render: (form) => (
                <div className={classes.actionButtonContainer}>
                  <Tooltip title="Open Form">
                    <IconButton href={`/forms/${form.id}`} target="blank" role="button" disabled={isLoading}>
                      <Icon>open_in_new</Icon>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Embed Form in Website">
                    <IconButton onClick={() => { setShowCodeForForm(form); }} role="button" disabled={isLoading}>
                      <Icon>code</Icon>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Edit Form">
                    <IconButton onClick={() => { onEditClick(form); }} role="button" disabled={isLoading}>
                      <Icon>edit</Icon>
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    title={form.archived
                      ? 'Restore Form'
                      : 'Archive Form'}
                  >
                    <IconButton onClick={() => { onArchiveClick(form); }} role="button" disabled={isLoading}>
                      <Icon>{form.archived
                        ? 'restore_from_trash'
                        : 'delete'}
                      </Icon>
                    </IconButton>
                  </Tooltip>
                </div>
              ),
            },
          ]}
        />
      </Grid>
      <Dialog
        open={!!showCodeForForm}
        maxWidth="md"
        onClose={() => { setShowCodeForForm(null); }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Embed Pingum Form In Your Website</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Copy the below iframe code snippet into your own website page
            so Pingum events can be created by anyone on your website
            without leaving or opening a new browser tab.
          </DialogContentText>
          <SyntaxHighlighter language="html" highlighter={'prism' || 'hljs'}>
            {`<iframe width="100%" height="750px" src="${window.location.origin}/forms/${showCodeForForm
              ? showCodeForForm.id
              : ''}"></iframe>`}
          </SyntaxHighlighter>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setShowCodeForForm(null); }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

FormsListComponent.propTypes = {
  forms: PropTypes.array,
  includeArchived: PropTypes.bool,
  isLoading: PropTypes.bool,
  onEditClick: PropTypes.func,
  onArchiveClick: PropTypes.func,
};
FormsListComponent.defaultProps = {
  forms: null,
  includeArchived: false,
  isLoading: false,
  onEditClick: () => {},
  onArchiveClick: () => {},
};

export default (FormsListComponent);
